import React, { useState } from "react";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { Button, Col, Form, Row } from "@payping/web-components";
import SelectCustomer from "@/components/DashInvoice/SelectCustomer";
import { OptionType } from "@payping/web-components/components/Select/sub/types";
import CreateCustomerModal from "@/pages/Shop/Invoice/forms/CreateCustomerModal";
import { Customer, CustomerConnection, InvoiceTypeEnum, SubmitType } from "@/pages/Shop/Invoice/forms/type";
import CreateCustomerCard from "@/pages/Shop/Invoice/Create/fourthStep/CreateCustomerCard";
import { FormInstance } from "@payping/web-components/components/Form/types";
import { InvoiceCreateResponseViewModel } from "@payping/api";
import { DropdownButton } from "@/core/component";

interface Props {
  selectedCustomer: Customer[];
  setSelectedCustomer: React.Dispatch<React.SetStateAction<Customer[]>>;
  isCorrectionMode: boolean;
  setSubmitType: React.Dispatch<React.SetStateAction<SubmitType>>;
  setManualPaymentNotesModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  manualPaymentNotesModalVisible: boolean;
  setInvoiceNotes: React.Dispatch<React.SetStateAction<string | undefined>>;
  prevStep: () => void;
  loading: boolean;
  form: FormInstance;
  handleCreate: (
    value: any,
    type: SubmitType,
    paidManualDescription?: string,
  ) => Promise<undefined | InvoiceCreateResponseViewModel[]>;
  submitType: SubmitType;
  invoiceNotes?: string;
  showInvoiceType: InvoiceTypeEnum;
}
const FourthStepInvoice: React.FC<Props> = (props: Props) => {
  const {
    selectedCustomer,
    setSelectedCustomer,
    isCorrectionMode,
    setSubmitType,
    loading,
    invoiceNotes,
    handleCreate,
    prevStep,
    showInvoiceType,
    form,
  } = props;
  const { t } = useAppTranslation();
  const [customerList, setCustomerList] = React.useState<OptionType[]>();
  const [createCustomerModalVisible, setCreateCustomerModalVisible] = useState(false);

  const onCreateCustomer = (customer: OptionType): void => {
    setCreateCustomerModalVisible(false);
    const fieldValues = form.getFieldsValue();
    setCustomerList((prev) => (prev ? [customer, ...prev] : [customer]));
    const newCustomer = { ...customer, type: "customer" };
    form.setFieldsValue({
      // ...fieldValues,
      customers: [...(fieldValues.customers || []), newCustomer],
    });
    setSelectedCustomer((prevState) => {
      return [
        ...prevState,
        {
          code: customer.value as string,
          fullName: customer.label as string,
          email: customer.email,
          phoneNumber: customer.phone,
          key: customer.key,
        },
      ];
    });
  };

  const saveMenu = [
    {
      key: 0,
      label: t("invoice.create.draft"),
      onClick: () => {
        setSubmitType("draft");
        form.submit();
      },
    },
  ];
  return (
    <Form<CustomerConnection>
      canDeactivate
      scrollToFirstError={{ behavior: "smooth" }}
      form={form}
      layout={"vertical"}
      onFinish={async (values) => {
        const tagIds = values.customers?.filter((obj) => obj.type === "category").map((tag) => tag.key);
        const customers = values.customers?.filter((obj) => obj.type !== "category").map((customer) => customer.key);

        await handleCreate(
          { ...values, customers, tagIds },
          showInvoiceType === InvoiceTypeEnum.cash ? "manual" : "send",
          invoiceNotes,
        );
      }}
      onValuesChange={(changedValues, values) => {
        if ("customers" in changedValues) {
          setSelectedCustomer([
            ...(values.customers?.map((value) => ({
              code: value.value,
              fullName: value.label,
              email: value.email,
              phoneNumber: value.phone,
              key: value.key,
            })) || []),
          ]);
        }
      }}
    >
      <Form.Item
        label={"جستجوی مشتری"}
        name={"customers"}
        rules={[
          {
            validator: () => {
              if (selectedCustomer?.length > 0) {
                return Promise.resolve();
              }
              return Promise.reject(new Error(t("common.validations.required", { name: t("customer.title") })));
            },
          },
        ]}
      >
        <SelectCustomer
          customerList={customerList}
          setCustomerList={setCustomerList}
          form={form}
          setCreateCustomerModalVisible={setCreateCustomerModalVisible}
          onCreateCustomer={onCreateCustomer}
        />
      </Form.Item>
      <Form.Item>{selectedCustomer?.map((item) => <CreateCustomerCard key={item.code} item={item} />)}</Form.Item>
      <CreateCustomerModal
        visible={createCustomerModalVisible}
        onCreateCustomer={onCreateCustomer}
        onCancel={(): void => {
          setCreateCustomerModalVisible(false);
        }}
      />
      <Form.Item>
        <Row gutter={[8, 8]}>
          <Col flex={2}>
            {isCorrectionMode ? (
              <Button block type={"primary"} htmlType={"submit"}>
                {t("invoice.create.submitModification")}
              </Button>
            ) : (
              <DropdownButton block menu={{ items: saveMenu }} type={"primary"} htmlType={"submit"} disabled={loading}>
                {t("invoice.create.sendInvoice")}
              </DropdownButton>
            )}
          </Col>
          <Col flex={1}>
            <Button block onClick={() => prevStep()}>
              {t("back")}
            </Button>
          </Col>
        </Row>
      </Form.Item>
    </Form>
  );
};

export default FourthStepInvoice;
